module.exports = __webpack_public_path__ + "img/park.5864901c.png";